import React from "react";

import PublicLayout from "../components/site/PublicLayout";

const linkClassName =
  "font-semibold text-yellow-500 underline-offset-2 hover:underline";

const ContactUs = () => {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-4xl px-4 pb-12 pt-4 sm:px-6 lg:pt-8">
        <h1 className="mb-6 text-3xl font-extrabold tracking-tight sm:text-4xl">
          Joignez-nous
        </h1>

        <div className="rounded-2xl bg-white p-6 text-gray-900 shadow-2xl shadow-black/40 sm:p-8">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            <div>
              <h2 className="text-lg font-bold">Téléphone #</h2>
              <p className="mb-5 mt-1">
                <a href="tel:+14505380486" className={linkClassName}>
                  +1 450 538-0486
                </a>
              </p>

              <h2 className="text-lg font-bold">Adresse</h2>
              <p className="mb-5 mt-1">4c Rue Maple, Sutton, QC J0E 2K0</p>

              <h2 className="text-lg font-bold">Médias sociaux</h2>
              <p className="mt-1">
                Instagram:{" "}
                <a
                  href="https://www.instagram.com/sutton_encore/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClassName}
                >
                  @sutton_encore
                </a>
              </p>
              <p className="mt-1">
                Facebook:{" "}
                <a
                  href="https://www.facebook.com/suttonencore/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClassName}
                >
                  Sutton Encore
                </a>
              </p>
            </div>

            <div>
              <h2 className="mb-2 text-lg font-bold">
                Emplacement sur la carte Google
              </h2>
              <iframe
                title="Emplacement sur la carte Google"
                className="h-72 w-full rounded-lg border border-gray-200"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2815.9473414578038!2d-72.61749598923501!3d45.107135470949615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cb61e7c65b40629%3A0xebc47f395cd5cae1!2s4c%20Rue%20Maple%2C%20Sutton%2C%20QC%20J0E%202K0%2C%20Canada!5e0!3m2!1sen!2sph!4v1716364653833!5m2!1sen!2sph"
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default ContactUs;
